module.exports = "::ng-deep .grand-total {\n  padding-bottom: 10px;\n  padding-right: 20px;\n  width: 100%;\n  text-align: right; }\n"